import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import ImgLazyLoad from "../../ImgLazyLoad";

interface QuickLinkersProps {}

interface InjectedProps extends QuickLinkersProps {
  homePageStore: HomePageStore;
}
const quickLinkers: React.SFC<QuickLinkersProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  const { quickLinkers } = homePageStore.homePageContent.response;
  return (
    <div className="subaru_quick-link_wrapper">
      <div className="subaru_quick-link_inner">
        <div className="subaru_links_items">
          {quickLinkers.map((item, i) => {
            return (
              <div className="subaru_item_link" key={`${item.title}`}>
                <div className="subaru_icon">
                  <ImgLazyLoad src={item.iconUrl} />
                </div>
                <h3>{item.title}</h3>
                <div className="subaru_link">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.link,
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default inject("homePageStore")(observer(quickLinkers));
